<template>
    <v-card elevation="0" class="annotation mb-0">
        <v-card-title class="text-subtitle-1 mb-2" style="border-bottom: 1px solid #efefef">
            <v-img max-width="25px" height="25px" class="rounded-circle mr-1" v-if="annotation.user_created.avatar"
                :src="`https://api.mylegis.com.br/assets/${annotation.user_created.avatar.id ? annotation.user_created.avatar.id : annotation.user_created.avatar }`" />
            <v-img max-width="25px" height="25px" class="rounded-circle mr-1" v-if="!annotation.user_created.avatar"
                contain src="../assets/icon-person.svg" />
            <router-link :to="`/painel/u/${slugName(annotation.user_created)}`" class="mr-2">
            {{
                annotation.user_created.first_name
                }}

                {{ annotation.user_created.last_name !== null ? annotation.user_created.last_name : "" }}
            </router-link>
            em
            <router-link class="ml-2" style="color: #000" :to="'/painel/lei/' +
                annotation.id_lei.id_lei +
                '/' +
                sanitizeTitle(annotation.id_lei.numero_lei)
                ">
                {{ annotation.id_lei.numero_lei }}
            </router-link>
        </v-card-title>
        <v-card-text class="annotationText">
            <p class="reg mx-0 "> {{ annotation.id_reg.conteudo }} </p>

            <p class="anno" v-html="annotation.texto"></p>
        </v-card-text>
        <v-card-actions class="d-flex flex-column" style="border-bottom: 1px solid #efefef">
            <div class="d-flex justify-end mb-0 w-100">
                <v-btn :disabled="user.plano === `plano-free` || user.plano ==``" text
                    @click="importPost = { ...annotation }; showNewAnnotation = true">
                    <v-icon small>mdi-import</v-icon> Importar post</v-btn>
            </div>
            <div class="px-4 d-flex align-center  justify-space-between w-100">
                <p class="mb-0">
                    <v-chip
                    @click="annotation.likes.some(l => l.id === user.id) ? unlikeAnnotation() : likeAnnotation()"
                     class="mr-1">
                        <v-icon small class="mr-1">mdi-thumb-up</v-icon> {{annotation.likes.length}}
                        {{  annotation.likes.some(l => l.id === user.id) ? "Descurtir" : `Curtir` }} 

                    </v-chip>
                    <v-chip @click="showComments = !showComments">
                        <v-icon small class="mr-1">mdi-comment</v-icon> {{ annotation.comentarios ? annotation.comentarios.length : 0 }} Comentários
                    </v-chip>
                </p>
                <p class="mb-0">
                    <span v-if="annotation.status === `group`">
                        <v-icon>mdi-account-group</v-icon>
                        {{ annotation.id_grupo.nome_grupo }}
                    </span>
                    <span v-else>
                        <v-icon small>{{
                            annotation.status === `private`
                                ? `mdi-lock`
                                : `mdi-earth`
                            }}</v-icon>
                        {{ annotation.status | filterStatus }}
                    </span>

                    <v-icon small class="ml-3">mdi-clock-outline</v-icon>
                    {{ annotation.date_updated === null ? "Criado em" : "Criado em" }}
                    {{ annotation.date_updated === null ? annotation.date_created : annotation.date_created | brdatetime
                    }}
                </p>

            </div>
            <v-list style="background-color:#efefef; border-radius:5px;" v-if="showComments" width="97.5%" class="mt-2  px-3">
                <h5 class="px-0"><v-icon small color="#F15A24">mdi-comment</v-icon> Comentários</h5>
                <v-list-item class="px-0">
                    <v-list-item-content>
                    <v-list-item-title class="d-flex align-center">
                        <v-textarea placeholder="Escreva aqui sua mensagem" rows="1" auto-grow counter v-model="comment"
                        append-icon="mdi-send" color="#F15A24" @click:append="postComment"
                        variant="underlined"></v-textarea>
                        <v-file-input style="max-width:100px" prepend-icon="mdi-paperclip"  hide-input v-model="file"
                        @change="handleFileAdded(file)"></v-file-input>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        <b v-if="commentFiles.length > 0">Anexos</b>
                        <p v-for="(f,index) in commentFiles" :key="f.id" class="pa-2" >
                         {{ f.filename_download }}
                             <v-icon @click="commentFiles.splice(index,1)">mdi-close</v-icon>
                         </p>
                    </v-list-item-subtitle>
                </v-list-item-content>

                </v-list-item>
                <v-list-item v-if="annotation.comentarios ? annotation.comentarios.length === 0 ? true : false : true " class="px-0">
                    <p class="text-center">
                        Seja o primeiro a comentar neste post, digite sua mensagem no campo acima e pressione o botão!
                    </p>
                </v-list-item>
                <v-list-item v-for="(item, i) in annotation.comentarios" :key="i" :value="item" color="primary" rounded="xl"
                    class="px-0">
                    <v-list-item-avatar>
                        <v-avatar color="grey"><v-img contain
                                :src="`https://api.mylegis.com.br/assets/${item.user_created.avatar.id ? item.user_created.avatar.id : item.user_created.avatar }`"></v-img></v-avatar>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title v-text="item.user_created.first_name"></v-list-item-title>
                        <v-list-item-subtitle v-text="item.message"></v-list-item-subtitle>
                        <v-list-item-subtitle class="mt-3">
                            <p v-for="(f) in item.files" :key="f.id" class="pa-2" >
                                <a :href="`https://api.mylegis.com.br/assets/${f.directus_files_id.id}?download`" target="_blank">
                                    {{ f.directus_files_id.filename_download}}
                                    <v-icon small >mdi-download</v-icon>

                                </a>
                                
                            </p>

                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action v-if="item.user_created.id == user.id">
                        <v-btn  color="grey darken-1"  icon 
                           @click="deleteComment(item.id)"><v-icon>mdi-delete</v-icon></v-btn>
                    </v-list-item-action>
                </v-list-item>
            </v-list>
        </v-card-actions>
        <v-dialog width="85vw" v-model="showNewAnnotation">
        <v-card class="px-5" >
            <v-card-title class="px-0">Importar Anotação <v-spacer />
            <v-btn @click="showNewAnnotation = false" text><v-icon large>mdi-close</v-icon></v-btn></v-card-title>
            <v-card-text>
            <h3></h3>
            <p class="pa-2" style="border: 1px dashed #f15a24">{{ importPost.id_lei.numero_lei }}</p>
            <p class=" mx-0 "> {{ importPost.id_reg.conteudo }} </p>
            <h3>Vade-mécum</h3>
					<v-select color="#F15A24" :items="vadeMecuns" v-model="importPost.id_vademecum"  item-text="titulo"
					item-value="id">
						<!-- <template v-slot:prepend-item="[item]">
							{{ item.id }}
						</template> -->
					</v-select>
            <h3>Visibilidade</h3>
            <v-select color="#F15A24" :items="statusAnnotation" v-model="importPost.status"></v-select>
            <h3 v-if="importPost.status == `group`">Selecione o grupo</h3>
            <v-select v-if="importPost.status == `group`" item-text="grupos_id.nome_grupo" item-value="grupos_id.id"
                color="#F15A24" :items="groups" v-model="importPost.id_grupo"></v-select>
            <h3 class="d-flex">
                Conteúdo
            </h3>
            <VueEditor use-custom-image-handler @image-added="handleImageAdded" ref="editor" color="#F15A24"
                :editor-toolbar="customToolbar" v-model="importPost.texto" />
            </v-card-text>
            <v-card-actions class="justify-end px-0">
            <v-btn text @click="showNewAnnotation = false">Cancelar</v-btn>
            <v-btn :loading="loadingNewAnnotation" dark @click="saveNewAnnotation()" color="#F15A24">Salvar
                <v-icon class="ml-1" small>mdi-content-save</v-icon></v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </v-card>

</template>
<style scoped>
h5 { 
    color:#F15A24 !important;
}

.annotation {
  border: 1px solid rgb(200 200 200) !important;
  margin: 8px 0px;
  border-radius: 10px;
}

.annotationText div {
  width: 100%;
}

.secondRow h3 {
  margin: 30px 0px 0px 15px;
}

.annotation ::v-deep img,
.comentario ::v-deep img {
  max-width: 100% !important;
}
.reg {
  background-color:#efefef;
  border-radius: 10px;
  padding: 15px;
}
.annotation ::v-deep  a { 
  color:black !important;
  text-decoration:underline;
  padding:0
}

a:hover, .annotation ::v-deep  a:hover { 
  text-decoration:underline;
  color:#F15A24 !important;

}
</style>
<script>

import { VueEditor } from "vue2-editor";
export default {
  name: "Annotation",
  components: { VueEditor},
  props: ["annotation"],
  data() { 
    return { 
        comment: "",
        commentFiles: [],
        file: null,
        showComments: false,
        importPost: { id_lei: {}, id_reg: {} },
        loadingNewAnnotation:false,
        showNewAnnotation: false,
        statusAnnotation: [
        { text: "Público", value: "published" },
        { text: "Grupo", value: "group" },
        { text: "Privado", value: "private" },
        { text: "Apenas Amigos", value: "friend" },
        { text: "Arquivado", value: "archived" },
      ],
      customToolbar: [
        [{ font: [] }, { size: [] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        // [{ script: "super" }, { script: "sub" }],
        [
          { header: "1" },
          { header: "2" },
          "blockquote",
          "code-block",
        ],

        [
          { list: "ordered" },
          { list: "bullet" },
          { indent: "-1" },
          { indent: "+1" },
        ],
        ["direction", { align: [] }],
        ["link", "image", "video"],
        ["clean"],
      ],
    }
  },
  computed: {
    groups() {
      return this.$store.state.user.grupos
    },
    user() {
      return this.$store.state.user;
    },
    vadeMecuns() { 
			return this.$store.state.vadeMecuns
		},
  
},
  methods: { 
    async reloadComments() {
        try {
            // window.console.log("vai")
            let rdm = Math.random()
            let fields = "id,message,user_created.id,user_created.first_name,user_created.avatar,files.directus_files_id.*"
            let {data} = await this.$http(`/items/comentarios?sort=-date_created&fields=${fields}&filter[status][_eq]=published&filter[annotation][_eq]=${this.annotation.id}&rdm=${rdm}`);
            // window.console.log(data)
            this.annotation.comentarios = data.data
        } catch (e) { window.console.log(e) }
    },
    async postComment() {
        try {
            if (this.comment.length > 1000) return
            // console.log(route.params)
            // const filter = { status:"published", asset: photo.value.id};
            const files = this.commentFiles.map(e => ({ directus_files_id: { id: e.id } })) 
            
            this.commentFiles.map(e => e.id)
            const {data} = await this.$http.post("/items/comentarios",{
                    annotation: this.annotation.id,
                    status: "published",
                    message: this.comment,
                    files: {create: files}
                });

            // selective.value = items[0]
            // window.console.log(data)

            if (data.data.id){
                this.comment=""
                this.commentFiles= []
                this.reloadComments()
            }
        } 
        catch (e) {
            window.console.log(e)
        }
    },
    async deleteComment(id) { 
         await this.$http.patch("/items/comentarios/"+id, {status: "draft"})
        // window.console.log(data)
        this.reloadComments()
    },
    async likeAnnotation() {
        const likes = { update: [{ id:this.user.id , curtidas:this.annotation.id }] }
        const {data} = await this.$http.patch("/items/anotacoes/"+ this.annotation.id, {likes})
        // window.console.log(data.data.likes)
        this.annotation.likes = data.data.likes        
    },
    async unlikeAnnotation() { 
        let idCurtida = null
        this.annotation.likes.find((l, i) => {
            if (l.id === this.user.id) {
                idCurtida = l.id
                this.annotation.likes.splice(i, 1)
            }
        })
        const likes = { delete: [idCurtida] }

        const {data} = await this.$http.patch("/items/anotacoes/"+ this.annotation.id, {likes})
        window.console.log(data.data.likes)
        this.annotation.likes = data.data.likes   
    },
    sanitizeTitle(title) {
      var slug = "";
      // Change to lower case
      var titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
      // Letter "d"
      slug = slug.replace(/đ/gi, "d");
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, "");
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, "-");

      return slug;
    },
    slugName(user) { 
        return user.id +"/"+ this.sanitizeTitle(user.first_name)
    },
    handleImageAdded(file, Editor, cursorLocation) {
      // window.console.log(file);
      const formData = new FormData();
      formData.append("image", file);
      this.$http
        .post("/files", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          // window.console.log(response);
          let url = `https://api.mylegis.com.br/assets/${response.data.data.id}`;
          Editor.insertEmbed(cursorLocation, "image", url);
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    handleFileAdded(file) {
            // window.console.log(file);
        const formData = new FormData();
        formData.append("file", file);
        this.$http
            .post("/files", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => {
                let file = response.data.data
                //window.console.log(file)
                this.commentFiles.push(file)
            })
            .catch((err) => {
                window.console.log(err);
            });
    },
    saveNewAnnotation() {
      this.loadingNewAnnotation = true;
      let dt = {
        id_lei: this.importPost.id_lei,
        id_reg: this.importPost.id_reg,
        status: this.importPost.status,
        id_grupo: this.importPost.status == `group` ? this.importPost.id_grupo : null,
        texto: this.importPost.texto,
        id_vademecum: this.importPost.id_vademecum
      };
      this.$http
        .post("items/anotacoes", dt)
        .then((response) => {
          if (response.data.data.id != undefined) {
            // this.reloadAnotacoes();
            this.loadingNewAnnotation = false;
            this.showNewAnnotation = false;
            // this.importPost = { status: "private" };
            this.importPost = { id_lei: {}, id_reg: {} },
              this.conteudoSelected = {};


            let conteudo = this.conteudos.find(
              (el) => el.id_reg === dt.id_reg
            );
            if (conteudo.anotacoes)
              conteudo.anotacoes.push(response.data.data);
            else conteudo.anotacoes = [response.data.data];
          }
        })
        .catch(() => {
          this.loadingNewAnnotation = false;
        });
    },
  }
}
</script>